<template>
  <!-- Payments alert Dialog -->
  <r-dialog id="payment-alert-dialog" :value="value" @input="onDialogClose">
    <div
      class="flex flex-col items-center bg-white rounded shadow-lg h-full p-4 relative"
    >
      <!-- title -->
      <div class="flex absolute left-0 ml-4">
        <div class="font-bold">
          {{ $t("payments.alertDialog.title") }}
        </div>
      </div>

      <!-- form -->
      <div class="h-full flex flex-col justify-center md:py-8 mt-6">
        {{ $t("payments.alertDialog.description") }}
      </div>

      <!-- buttons -->
      <div class="flex flex-row justify-between w-full mt-5">
        <!-- Checkbox -->
        <div class="flex flex-wrap justify-end content-end mb-1">
          <input
            type="checkbox"
            :class="inputClasses"
            @change="onCheckboxChange"
            :checked="isChecked"
          />
          <span class="ml-2 text-gray-900">
            {{ $t("payments.alertDialog.checkbox") }}
          </span>
        </div>

        <!-- ok -->
        <r-button id="ok-payments-dialog" @click="onDialogClose">
          {{ $t("buttons.ok") }}
        </r-button>
      </div>
    </div>
  </r-dialog>
</template>

<script>
export default {
  // local state
  data() {
    return {
      isChecked: false
    }
  },

  // props
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  // computed properties
  computed: {
    inputClasses() {
      return {
        "form-checkbox": true,
        "h-5": true,
        "w-5": true,
        "text-gray-600": true,
        "cursor-pointer": !this.isCheckboxDisable,
        "cursor-not-allowed": this.isCheckboxDisable
      }
    }
  },

  // methods
  methods: {
    /**
     * On close dialog
     */
    onDialogClose() {
      // set to local storage
      if (this.isChecked) {
        localStorage.setItem("payment-dialog", true)
      }

      this.$emit("input", false)
    },

    /**
     * on Checkbox Change
     */
    onCheckboxChange() {
      this.isChecked = !this.isChecked
    }
  }
}
</script>
